import { FraudStatementSearchResponse, FraudStatementSearchRequestQuery } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { config } from '@services/config';
import { queryFraudStatementsKeys } from './keys';
import { getFraudStatementQuery } from './helpers';

export const useSearchFraudStatements = (params: FraudStatementSearchRequestQuery) => {
  const client = useClient();

  const queryParams = getFraudStatementQuery(params);

  const result = useQuery<FraudStatementSearchResponse, Error>({
    ...config,
    queryKey: queryFraudStatementsKeys.searchWithParams(params),
    queryFn: () => client.get(`fraud-statement?${queryParams}`).json<FraudStatementSearchResponse>(),
    enabled: true,
  });

  return { ...result, items: result.data?.items || [] };
};
